import * as React from "react";

const SKELETON_FILTER_COUNT = 5;

const SkeletonFilterButton: React.FC = () => {
  return (
    <div className="skeleton-filter">
      <div className="skeleton-filter-text skeleton-shimmer" />
      <div className="skeleton-filter-icon skeleton-shimmer" />
    </div>
  );
};

export const SkeletonFilters: React.FC = () => {
  const filters = Array.from({ length: SKELETON_FILTER_COUNT }, (_, index) => (
    <SkeletonFilterButton key={`skeleton-filter-${index}`} />
  ));

  return <div className="skeleton-filters">{filters}</div>;
};
